export const SET_SELECTED_PRODUCTS = "productDocuments/SET_SELECTED_PRODUCTS"
export const SET_SELECTED_TYPE_KEYS = "productDocuments/SET_SELECTED_TYPE_KEYS"

export const setSelectedProducts = (products) => ({
    type: SET_SELECTED_PRODUCTS,
    payload: products,
})

export const setSelectedTypeKeys = (typeKeys) => ({
    type: SET_SELECTED_TYPE_KEYS,
    payload: typeKeys,
})
